export default {
  install: function (Vue, options) {
    // base = 'https://resources.laihua.com';
    let { base } = options;
    Vue.prototype.$handleAssetsUrl = function (url) {
      if (!url) {
        return ''
      }
      const httpReg = /^http/;
      if (httpReg.test(url)) {
        return url;
      }
      const reg = /^\//;
      if (!reg.test(url)) {
        return base + '/' + url;
      } else {
        return base + url;
      }
    }
    Vue.prototype.$unhandleAssetsUrl = function (url) {
      return url ? url.replace(/https:\/\/resources.laihua.com(\/)?/, '') : '';
    }
  }
};



// WEBPACK FOOTER //
// ./src/plugins/handleAssetsUrl.js